"use client";

import { DetailHero } from "@/components/detail-hero";
import { ListMusic } from "lucide-react";
import { AsyncBoundary, EmptyState } from "@gerama/ui";
import { formatNumber } from "@gerama/utils";
import { usePlaylist, usePlaylistSongs } from "./use-playlist";
import { PlaylistDetailSkeleton } from "./playlist-detail-skeleton";
import { SongRow } from "@/features/songs/song-row";
import { PlayButton } from "@/features/player/play-button";
import { songToTrack } from "@/features/player/to-track";

export function PlaylistDetail({ id }: { id: number }) {
  const playlistQuery = usePlaylist(id);
  const songsQuery = usePlaylistSongs(id);

  return (
    <AsyncBoundary
      variant="immersive"
      query={playlistQuery}
      skeleton={<PlaylistDetailSkeleton />}
      isEmpty={() => false}
      empty={
        <EmptyState
          variant="immersive"
          icon={<ListMusic className="size-8" />}
          title="پلی‌لیست یافت نشد"
        />
      }
      render={(playlist) => {
        const songs = songsQuery.data?.list ?? [];
        const queue = songs.map((s) => songToTrack(s));
        return (
          <article className="space-y-4">
            <DetailHero
              kind="پلی‌لیست"
              title={playlist.name}
              cover={playlist.cover}
              seed={`playlist-${playlist.id}`}
              fallbackIcon={<ListMusic className="size-14" />}
              meta={`${formatNumber(playlist.songCount, "fa")} آهنگ`}
              actions={
                queue[0] && (
                  <PlayButton
                    track={queue[0]}
                    queue={queue}
                    contextLabel={playlist.name}
                    contextHref={`/playlists/${playlist.id}`}
                    appearance="hero"
                  />
                )
              }
            />

            <AsyncBoundary
              variant="immersive"
              query={songsQuery}
              skeleton={<PlaylistDetailSkeleton />}
              empty={<EmptyState variant="immersive" title="آهنگی در این پلی‌لیست نیست" />}
              render={(list) => (
                <div className="space-y-1">
                  {list.list.map((song, i) => (
                    <SongRow
                      key={song.id}
                      song={song}
                      index={i}
                      queue={queue}
                      contextLabel={playlist.name}
                      contextHref={`/playlists/${playlist.id}`}
                    />
                  ))}
                </div>
              )}
            />
          </article>
        );
      }}
    />
  );
}
